import { u as unFunction } from "../../utils/un-function.js";
const isStepHasError = (step) => {
  return unFunction(step.hasError, step) || false;
};
export {
  isStepHasError as i
};
//# sourceMappingURL=step.js.map
